import React from "react";

/**
 * Component to display a message when embedded content is blocked due to cookie consent
 */
const CookieBlockedMessage = ({ 
  style = {}, 
  onClick,
  dimensions 
}) => {
  const handleOpenCookieSettings = (e) => {
    e.stopPropagation(); // Prevent any parent click handlers
    
    // Dispatch custom event to request opening cookie consent modal
    // EditKdfPage listens to this event and opens the modal
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('openCookieConsentModal'));
    }
  };

  const defaultStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    backgroundColor: "#f5f5f5",
    border: "2px solid var(--cancel)",
    borderRadius: "8px",
    padding: "20px",
    textAlign: "center",
    color: "#666",
    fontSize: "14px",
    lineHeight: "1.5",
    cursor: onClick ? "pointer" : "default",
    ...style,
  };

  const linkStyle = {
    color: "#0066cc",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: "13px",
    marginTop: "12px",
    fontWeight: "500",
  };

  return (
    <div 
      style={defaultStyle}
      onClick={onClick}
      title="Accept all cookies to view this content"
    >
      <div style={{ marginBottom: "10px" }}>
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ opacity: 0.6 }}
        >
          <path
            d="M9 16H9.01M12 11H12.01M7 10H7.01M15 16H15.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C12 5.76142 13.7909 8 16 8C16 10.2091 18.2386 12 21 12Z"
            stroke="var(--cancel)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div style={{ fontWeight: "600", marginBottom: "8px", color: "#333" }}>
        Content Unavailable
      </div>
      <div style={{ fontSize: "12px", color: "#888" }}>
        Please accept all cookies to view embedded content
      </div>
      <div 
        style={linkStyle}
        onClick={handleOpenCookieSettings}
        onMouseEnter={(e) => e.target.style.color = "#0052a3"}
        onMouseLeave={(e) => e.target.style.color = "#0066cc"}
      >
        Change cookie settings
      </div>
    </div>
  );
};

export default CookieBlockedMessage;

